import { connect } from 'react-redux'
import SelectClient from '../components/SelectClient'

const mapStateToProps = (state, ownProps) => ({
  defaults: state.environments.defaults,
  handleChange: ownProps.handleChange,
  onBlur: ownProps.onBlur,
  value: ownProps.value,
  validation: ownProps.validation,
  label: ownProps.label
})

export default connect(
  mapStateToProps
)(SelectClient)
